import { Box, Button, Card, Paragraph } from '@zillow/constellation-10';

import { AUTO_FREQUENCY, MANUAL_FREQUENCY } from '@renter-hub/constants/paymentConstants';
import { IconCheckmarkCircleFilled, IconCircleOutline } from '@zillow/constellation-icons';

interface Props {
  frequencyType: string;
  setFrequencyType: (frequencyType: string) => void;
}

const PaymentFrequencyPage = ({ setFrequencyType, frequencyType }: Props) => {
  const autoPaySelected = frequencyType === AUTO_FREQUENCY;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Box>
        <Card
          outlined
          interactive
          elevated={false}
          css={{
            padding: 'token(spacing.md) !important',
            display: 'flex',
            alignItems: 'center',
            marginBottom: 'token(spacing.sm) !important',
          }}
          onClick={() => setFrequencyType(AUTO_FREQUENCY)}
        >
          <Box
            css={{
              marginRight: 'token(spacing.md) !important',
            }}
          >
            <Paragraph textStyle="body-bold">Autopay/recurring</Paragraph>
          </Box>
          <Box
            css={{
              marginLeft: 'auto !important',
            }}
          >
            {autoPaySelected ? (
              <Button.Icon>
                <IconCheckmarkCircleFilled />
              </Button.Icon>
            ) : (
              <Button.Icon>
                <IconCircleOutline />
              </Button.Icon>
            )}
          </Box>
        </Card>
        <Card
          outlined
          interactive
          elevated={false}
          css={{
            padding: 'token(spacing.md) !important',
            display: 'flex',
            alignItems: 'center',
          }}
          onClick={() => setFrequencyType(MANUAL_FREQUENCY)}
        >
          <Box
            css={{
              marginRight: 'token(spacing.md) !important',
            }}
          >
            <Paragraph textStyle="body-bold">One at a time</Paragraph>
          </Box>
          <Box
            css={{
              marginLeft: 'auto !important',
            }}
          >
            {!autoPaySelected ? (
              <Button.Icon>
                <IconCheckmarkCircleFilled />
              </Button.Icon>
            ) : (
              <Button.Icon>
                <IconCircleOutline />
              </Button.Icon>
            )}
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default PaymentFrequencyPage;
